// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectWrapper__cb1 {
  width: 100%;

  .input__df1 {
    width: 100%;
    max-width: calc(var(--ring-unit) * 59);
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugins-rule/single-plugin-rule/common/plugin-selector/plugin-selector-anchor/plugin-selector-anchor.css"],"names":[],"mappings":"AAAA;EACE,WAAW;;EAEX;IACE,WAAW;IACX,sCAAsC;EACxC;AACF","sourcesContent":[".selectWrapper {\n  width: 100%;\n\n  .input {\n    width: 100%;\n    max-width: calc(var(--ring-unit) * 59);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectWrapper": `selectWrapper__cb1`,
	"input": `input__df1`
};
export default ___CSS_LOADER_EXPORT___;
